import { ReactElement } from 'react';
import { S_ListSelect } from '../../../../../../../../design/inputs/select/S_ListSelect';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const ReviewedByBody = ({ availableFilters, imageFilters, onSetReviewedBy }: ImageFiltersFormProps): ReactElement => {
  const options = availableFilters.reviewedBy.map((x) => ({ value: x.id, label: x.email, searchableLabel: x.email }));

  return (
    <FilterContent>
      <S_ListSelect
        options={options}
        selected={imageFilters.reviewedBy}
        onChange={onSetReviewedBy}
      />
    </FilterContent>
  );
};
